"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultTheme = {
  MuiTablePagination: {
    root: {
      paddingRight: '50px',
      borderTop: '3px solid #42779a'
    },
    toolbar: {
      minHeight: '45px'
    }
  },
  MuiTypography: {
    body2: {
      fontSize: '14px',
      textTransform: 'uppercase'
    },
    root: {
      fontSize: '14px'
    }
  },
  MuiIconButton: {
    root: {
      padding: '2px'
    }
  }
};
var CustomPagination = function CustomPagination(_ref) {
  var rowsPerPageOptions = _ref.rowsPerPageOptions,
    count = _ref.count,
    rowsPerPage = _ref.rowsPerPage,
    page = _ref.page,
    onPageChange = _ref.onPageChange,
    onRowsPerPageChange = _ref.onRowsPerPageChange,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? {} : _ref$customTheme;
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: (0, _core.createTheme)({
      overrides: _objectSpread(_objectSpread({}, defaultTheme), customTheme)
    })
  }, /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    rowsPerPageOptions: rowsPerPageOptions,
    component: "div",
    count: count,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange
  }));
};
CustomPagination.propTypes = {
  rowsPerPageOptions: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  count: _propTypes.default.number.isRequired,
  rowsPerPage: _propTypes.default.number.isRequired,
  page: _propTypes.default.number.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  onRowsPerPageChange: _propTypes.default.func.isRequired
};
var _default = CustomPagination;
exports.default = _default;